import router from '@/router';

function parseJWT(accessToken) {
  return JSON.parse(atob(accessToken.split('.')[1]));
}

function checkExpired(getters) {
  const jwt = getters.jwt;
  if (jwt) {
    const exp = jwt.exp;
    const now = Math.trunc(Date.now() / 1000);
    const delta = exp - now;

    // on compte 10 minutes de répit
    return delta < 600;
  }
  return true;
}

const storage = window.sessionStorage;

function loadItem(key) {
  const item = storage.getItem(key);
  try {
    return JSON.parse(item);
  } catch (e) {
    storage.removeItem(key);
  }
}

function storeItem(key, value) {
  if (value && Object.keys(value).length > 0) {
    storage.setItem(key, JSON.stringify(value));
  } else {
    storage.removeItem(key);
  }
}

/**
 * Creation de la hierarchy de role
 */
function grantedAuthorities(authorities, hierarchy) {
  if (authorities && hierarchy) {
    const set = {};
    var lookup = Array.from(authorities);
    while (lookup.length) {
      const current = lookup.pop();
      if (!set[current]) {
        set[current] = true;

        const implied = hierarchy
          .filter(i => i.role === current)
          .map(i => i.implies);
        if (implied.length) {
          lookup = lookup.concat(implied);
        }
      }
    }
    return Object.keys(set);
  }

  return authorities;
}

const TO_HOME = {
  name: 'home',
};
const TO_LOGIN = {
  name: 'login',
};

// window.sessionStorage
export default {
  namespaced: true,
  state: {
    oauth: loadItem('oauth'),
    redirectAfterLogin: TO_HOME,
    user: loadItem('user'),
    hierarchy: [],
  },

  getters: {
    logged: state => state.oauth != null,
    access_token: (state, getters) =>
      getters.logged ? state.oauth.access_token : null,
    refresh_token: (state, getters) =>
      getters.logged ? state.oauth.refresh_token : null,
    jwt: (state, getters) =>
      getters.access_token ? parseJWT(getters.access_token) : null,
    authorities: (state, getters) =>
      getters.jwt ? getters.jwt.authorities : null,
    grantedAuthorities: (state, getters) =>
      grantedAuthorities(getters.authorities, state.hierarchy),
    username: state => (state.user ? state.user.name : null),
    userid: state => (state.user ? state.user.id : null),
    user: state => state.user,
    nomComplet: state => (state.user ? state.user.nomComplet : null),
    expired: (state, getters) => () => {
      return checkExpired(getters);
    },
  },

  mutations: {
    /**
     * Mise en place d'un token oauth
     */
    token(state, oauth) {
      state.oauth = oauth;
      storeItem('oauth', oauth);
    },

    /**
     * Mise en place du user
     */
    user(state, user) {
      state.user = user;
      storeItem('user', user);

      if (user == null) {
        // logout
        router.push({ name: 'login' });
      } else {
        // gestion de la navigation
        router.push(state.redirectAfterLogin);
      }
    },
  },

  actions: {
    /**
     * Permet de renvoyer vers la page de login et de conserver la destination après le login
     */
    loginAndRedirect({ state }, to) {
      // TODO gestion du path ou autre...
      state.redirectAfterLogin = {
        name: to.name,
        params: to.params,
      };

      router.push({
        name: TO_LOGIN,
      });
    },
  },
};
